export { App } from "./app/App";

// require("expose-loader?$!jquery");
// import jquery from 'script-loader!jquery';
require("expose-loader?App!./app/App");



// WEBPACK FOOTER //
// ./src/script/app-wrapper.ts